import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IMultipleIdsParams } from '../types/actionParams';
import { IActionResult } from '../types/IActionResult';

export class EnableDatabaseControlledPermissionsRequest
    extends Request<IMultipleIdsParams, IActionResult> {
  constructor(ids: string[]) {
    super('enableDatabaseControlledPermissions', {
      ids: ids
    });
  }
}

export class DisableDatabaseControlledPermissionsRequest
  extends Request<IMultipleIdsParams, IActionResult> {
  constructor(ids: string[]) {
    super('disableDatabaseControlledPermissions', {
      ids: ids
    });
  }
}
